import React from 'react';
import { Grid } from 'semantic-ui-react';

import EventSummarySchedule from 'components/EventSummarySchedule';
import { SPRAY_EVENT_WIZARD_SCHEDULE_STEP } from 'services/sprayEventWizard/constants';
import FieldValues from 'components/FieldValues';
import { SprayEventOperatorsIndex } from 'services/sprayEvents/types';
import { isMultiOperatorApplicationType } from 'services/sprayEvents/utils';
import SummaryBlocks from './components/SummaryBlocks';
import MultipleApplicatorsTab from '../MultipleOperatorsTab';
import SummaryWrapper from './components/SummaryWrapper';

interface Props {
    readOnly?: boolean;
}

export default function SummaryPage(props: Props): React.ReactElement {
    const { readOnly = false } = props;

    return (
        <div className="spray-event-modal-step || spray-event-summary">
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <h4 className="summary-title">Review Summary</h4>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <EventSummarySchedule
                readOnly={readOnly}
                eventWizardStep={SPRAY_EVENT_WIZARD_SCHEDULE_STEP}
            >
                <SummaryBlocks />
            </EventSummarySchedule>
            <FieldValues
                fieldNames={['applicationType', 'sprayEventOperations']}
            >
                {({
                    applicationType,
                    sprayEventOperations
                }): React.ReactElement => {
                    if (isMultiOperatorApplicationType(applicationType)) {
                        return (
                            <MultipleApplicatorsTab
                                needSetActiveIndexToState
                                childForOutsideRowTab={
                                    <SummaryWrapper
                                        readOnly={readOnly}
                                        sprayEventOperation={
                                            sprayEventOperations[
                                                SprayEventOperatorsIndex.OUTSIDE
                                            ]
                                        }
                                    />
                                }
                                childForDoubleRowTab={
                                    <SummaryWrapper
                                        readOnly={readOnly}
                                        sprayEventOperation={
                                            sprayEventOperations[
                                                SprayEventOperatorsIndex.DOUBLE
                                            ]
                                        }
                                    />
                                }
                            />
                        );
                    }

                    return (
                        <SummaryWrapper
                            readOnly={readOnly}
                            sprayEventOperation={
                                sprayEventOperations[
                                    SprayEventOperatorsIndex.STANDARD
                                ]
                            }
                        />
                    );
                }}
            </FieldValues>
        </div>
    );
}
